import React from 'react';
import moment from 'moment';

import EventIcon from './event-icon';
import style from './index.less';

export const EventCopyButton = props => {
  const { data } = props;
  const { action, content, time, body } = data;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>{content}</li>
      </ul>
      <div className={style['event-border']} />
      <div className={style['cp-btn-info']}>
        <span>{body?.name}</span>
        <span>{body?.value}</span>
      </div>
    </div>
  );
};
